
import '../scss/boiler-legislation-new-boilers.scss';
import '../icons/ketelkiezer_thermostat.svg';

const angular = require('angular');
const angularAnimate = require('angular-animate');

(function() {
    "use strict";
    var myApp = angular.module("legislation-new-boilers", ['ngAnimate']);

    // Custom filter object to array
    myApp.filter('array', ['$filter', function($filter) {
        return function(items) {

            var filtered = [];

            angular.forEach(items, function(item) {
                filtered.push(item);
            });


            return filtered;
        };
    }]);



    myApp.directive('myclick', ['$timeout', function($timeout) {

        return function(scope, element, attrs) {

            element.bind('touchstart click', function(event) {


                var timer;

                event.preventDefault();
                event.stopPropagation();


                if (timer) {
                    $timeout.cancel(timer);
                }
                timer = $timeout(function() {
                    scope.$apply(attrs['myclick']);
                }, 100);

            });
        };
    }]);



    myApp.filter('boilerControlFilter', function() {
        return function(items, data, scope) {

            var filtered = [];
            var tmp_arr = [];

            if(items){

                //console.log('data' , data);


                if( data[1] == 1  ){
                    data = data[6];
                }


                if( data[1] == 0 ){
                    data = data[5];
                }


            // Ser all items to same level (hierarchy)
            angular.forEach(items, function(item, key) {
                angular.forEach(item.related, function(boiler, key) {
                    if( boiler.connected_boilercontrols[data] ){
                        tmp_arr.push(boiler);
                    }
                });
            });

            //console.log( tmp_arr );

            items = tmp_arr;

            angular.forEach(items, function(item, key) {


                var check = true;

                    ///////////////////////////////////////
                    // filter min heating power ///////////
                    ///////////////////////////////////////

                    // fix when no data has been loaded by $scope.alleKetels()
                    if (item == 0) {
                        item = {
                            data: {}
                        };
                    }


                 
                    filtered.push(item);
                 


                });
        }


        return filtered;

    };
})

    myApp.controller("legislation-new-boilers-controller", ['$scope', '$timeout', '$http', '$window', '$filter', function ($scope, $timeout, $http, $window, $filter) {


        $scope.selectedBoilers = [];


        // Recive all boilers
        $scope.alleKetels = function() {

            $scope.allBoilers = {};
            var filterTypes = ['heating + hot water', 'only hot water', 'heat only', 'hybrid solutions'];


            $http({
                method: 'POST',
                url: '/wp-admin/admin-ajax.php',
                headers: {
                    'Content-Type': 'application/json'
                },
                params: {
                    action: 'Boilers', // (zie functions.php in root)
                    filter: filterTypes.toString(),
                    nonce: ajax_var.nonce,
                    function: 'allTypes',
                    uitsluitingen: $scope.uitsluitingen,
                    current_section: $scope.current_section
                }
            }).then(function(data) {

                $scope.allBoilers = data.data;
               // console.info('data.data', data.data );

                $timeout(function() {
                    $scope.appReady = {
                        opacity: 1,
                        transition: '0.5s'
                    };
                });

            });
        };



      



        $scope.selectType = function(boiler){
            $scope.GroupTitle = boiler.title;
            $scope.relatedBoilers = boiler.related;
            $scope.viewSwitch('viewRelated');
        };



        // check all selected boilers
        $scope.selectBoiler = function(event, index, boiler) {


            $timeout(function() {

                angular.forEach( $scope.relatedBoilers , function(value, key) {
                    delete $scope.relatedBoilers[key].active;
                });

                boiler.active = true;
                $scope.selectedBoilers = {0:boiler}

               // console.log( boiler )
                $scope.selectedBoilerCount = Object.keys( $scope.selectedBoilers ).length; 
                //console.log($scope.selectedBoilers);

                $scope.viewSwitch('viewResultByMatchingBoiler');

            });
        };

        
        // Check all selected thermostats
        // $scope.selectThermostat = function(event, index, thermostats) {
        //     $timeout(function() {

        //         angular.forEach( $scope.allThermostats , function(value, key) {
        //             delete $scope.allThermostats[key].active;
        //         });

        //         thermostats.active = true;
        //         $scope.selectedThermostat = thermostats;

        //         $scope.selectedTHCount = Object.keys(  $scope.selectedThermostat  ).length; 

        //         //console.log($scope.selectedThermostat);
        //         $scope.viewSwitch('viewDownload');
        //     });
        // };


        $scope.view = 'types';

        $scope.viewSwitch = function(page){

            switch(page){


                /////////// SELECT BOILER ////////////
                case 'viewTypes':
                $scope.view = 'types';
                break;

                case 'viewRelated':
                $scope.view = 'related';
                break;


                /////////// KEUZE MENU ////////////

                case 'viewChoiceMenu':
                $scope.gotoStap(0);
                $scope.view = 'choiceMenu';
                break;

                case 'viewBackToChoiceMenu':
                $scope.gotoStap( $scope.stap - 2 );
                $scope.view = 'choiceMenu';
                break;
                

                /////////// RESULT by TYPE OF CONTROL ////////////
                case 'viewResultByMatchingControls':
                $scope.view = 'resultByMatchingControls';
                break;


                /////////// RESULT by BOILER ////////////
                case 'viewResultByMatchingBoiler':
                $scope.view = 'resultByMatchingBoiler';
                break;

                // case 'viewDone':
                // $scope.view = 'done';
                
                // $timeout(function(){
                //     $scope.viewSwitch('viewTypes');
                // },3000);

                //console.log( 'done' );
                break;

            }

        };













        // define all vars
        $scope.stap = 0;
        $scope.verwarmen = true;
        $scope.done = false;
        $scope.situatie_gegevens = {};
        $scope.ketelkiezer_ingevuld = true;
        $scope.showLimit = 300;

        $scope.hideBack = false;

        // Filter keuze opties
        $scope.filter = function(e) {
            // Verwarming nodig?


            // $scope.form[1].filter = true; //Does it have a central heating timer and thermostat?
            // $scope.form[2].filter = true; //Does it have a timer and thermostat?
            // $scope.form[3].filter = true; //Does it have a timer and thermostat?
            // $scope.form[4].filter = true; //Does it have a timer and thermostat?
            
            

            $scope.form[2].filter = false;
            $scope.form[3].filter = false;
            $scope.form[4].filter = false;
            $scope.form[5].filter = false;
            $scope.form[6].filter = false;
            // $scope.form[5].filter = false;
            //$scope.form[6].filter = false;

            // combi yes / no
            if ($scope.form[0].velden[0].status && $scope.form[0].velden[0].status == 'active') {
                $scope.combi = true;
                $scope.form[1].filter = true;
            }else{
                $scope.form[2].filter = true;
                $scope.combi = false;
            }



            if ($scope.combi == true ){
             if ($scope.form[1].velden[0].status && $scope.form[1].velden[0].status == 'active') {
                $scope.form[5].filter = true;
            }else{
                $scope.form[6].filter = true;
            }
        }

        // No combi > Does it have a timer and thermostat yes / no
            if ($scope.combi == false ){
            if ($scope.form[2].velden[0].status && $scope.form[2].velden[0].status == 'active') {
                $scope.form[3].filter = true;
                $scope.form[4].filter = false;
            }else{
                $scope.form[3].filter = false;
                $scope.form[4].filter = true;
            }
        }

            // goto next step
            $scope.next();

        };



        var timer;

        // Click event
        $scope.toggleActive = function(rowIndex, valueIndex) {

            // remove all active classes from current rowIndex element
            angular.forEach($scope.form[rowIndex].velden, function(value, key) {
                delete value.status;
            });

            // Add active class to clicked element
            $scope.form[rowIndex].velden[valueIndex].status = 'active';

            $scope.situatie_gegevens[rowIndex] = $scope.form[rowIndex].velden[valueIndex].value;

            // Filter product array
            $scope.filter();


        };



        // Goto next question
        $scope.next = function() {

            $scope.hideBack = false;

            $scope.stap++;

            for (var veld in $scope.form) {
                if ($scope.form[$scope.stap] && $scope.form[$scope.stap].filter == false) {
                    $scope.stap++;
                }
            }


            // if ($scope.stap == 4){
            //     angular.forEach($scope.allBoilers, function (relatedBoilers, key){
            //         angular.forEach(relatedBoilers.related, function (relatedBoiler, key){
                   
            //             if (Object.keys(relatedBoiler.connected_boilercontrols).length == 0 ){
            //                 $scope.selectedBoilers.push(relatedBoiler);
            //             }
            //         })
            //     });
            //     // $timeout( function(){
            //     //     $scope.viewSwitch('viewResultByMatchingControls');
            //     // },3000)
            // }

            var count = Object.keys($scope.form).length;
            if ($scope.stap == count) {
                $scope.done = true;

                $scope.viewSwitch('viewResultByMatchingControls');

                return false;
            }


        };





        // Ga naar een specifieke vraag
        $scope.gotoStap = function(index) {
            //console.log($scope.stap, index)

            if (index >= $scope.stap) return false;

            // wis selectie in navolgende stappen
            angular.forEach($scope.form, function(value, key) {
                if (key > index) {
                    $scope.situatie_gegevens[key] = '';
                    angular.forEach($scope.form[key].velden, function(formvalue, veldkey) {
                        $scope.form[key].velden[veldkey].status = '';
                    });
                }
            });

            $scope.hideBack = true;
            $scope.done = false;
            $scope.stap = index;

        };



        /**
         * 
         * @description Return false if boilercontrols are found in given Array
         * @param {array} dataItems 
         * 
         */
        $scope.noMatchingControls = function(dataItems){
            var output = true;

            angular.forEach(dataItems, function (value, key){
                angular.forEach(value.connected_boilercontrols, function (formvalue, veldkey) {
                    output = false;
                    return;
                });
            });

            return output;

        }




        // Het dynamische formulier
        $scope.form = {
            0: {
                type: 'flex',
                tekst: 'Is it a combi boiler?',
                shortTekst: "Ketel",
                filter: true,
                icons: {
                    0: 'ketelkiezer_warmwater.svg',
                    1: 'ketelkiezer_verwarming.svg',
                },
                velden: {
                    0: {
                        label: 'Yes',
                        value: '0'
                    },
                    1: {
                        label: 'No',
                        value: '1',
                    },
                }
            },

            // if 0 === yes
            1: {
                type: 'flex',
                tekst: 'Does it have a central heating timer and thermostat?',
                shortTekst: "Ketel",
                filter: false,
                icons: {
                    0: 'ketelkiezer_thermostat.svg',
                },
                velden: {
                    0: {
                        label: 'Yes',
                        value: '0'
                    },
                    1: {
                        label: 'No',
                        value: '1',
                    },
                }
            },



            // if 0 === no
            2: {
                type: 'flex',
                tekst: 'Does it have a timer and thermostat?',
                shortTekst: "Ketel",
                filter: false,
                icons: {
                    0: 'ketelkiezer_thermostat.svg',
                },
                velden: {
                    0: {
                        label: 'Yes',
                        value: '0'
                    },
                    1: {
                        label: 'No',
                        value: '1',
                    },
                }
            },
            // if 2 === yes
            3: {
                type: 'flex',
                tekst: 'There are no additional components required',
                shortTekst: "Ketel",
                filter: false,
                icons: {
                    0: 'ketelkiezer_warmwater.svg',
                },
            },
            // if 2 === no
            4: {
                type: 'flex',
                tekst: 'Central heating timer and thermostat te be installed with boiler',
                shortTekst: "Ketel",
                filter: false,
                icons: {
                    0: 'ketelkiezer_warmwater.svg',
                },
            },




            5: {
                type: 'row',
                kop: 'Controls meet requirements!',
                tekst: 'Select one of the following to be installed alongside the combi boiler',
                shortTekst: "Ketel",
                filter: true,
                velden: {
                    0: {
                        label: 'Flue gas heat recovery',
                        value: 'flue_gas_recovery'
                    },
                    1: {
                        label: 'Weather compensation',
                        value: 'weather_compensation_device'
                    },
                    2: {
                        label: 'Load compensation',
                        value: 'load_compensation_device'
                    },
                    3: {
                        label: 'Smart Heating controls',
                        value: 'smart_heating_controls'
                    }
                }
            },


            6: {
                type: 'row',
                kop: 'Central heating timer and thermostat te be installed with boiler',
                tekst: 'Select one of the following to be installed alongside the combi boiler',
                shortTekst: "Ketel",
                filter: true,
                velden: {
                    0: {
                        label: 'Flue gas heat recovery',
                        value: 'flue_gas_recovery'
                    },
                    1: {
                        label: 'Weather compensation',
                        value: 'weather_compensation_device'
                    },
                    2: {
                        label: 'Load compensation',
                        value: 'load_compensation_device'
                    },
                    3: {
                        label: 'Smart Heating controls',
                        value: 'smart_heating_controls'
                    }
                }
            },







            // 2: {
            //     tekst: 'Next',
            //     shortTekst: "Issolatie",
            //     filter: true,
            //     velden: {
            //         0: {
            //             label: 'Goed',
            //             value: '0',
            //             icons: {
            //                 0: 'ketelkiezer_isolatie_goed.svg',

            //             }
            //         },
            //         1: {
            //             label: 'Gemiddeld',
            //             value: '1',
            //             icons: {
            //                 0: 'ketelkiezer_isolatie_gemiddeld.svg',

            //             }
            //         },
            //         2: {
            //             label: 'Minimaal',
            //             value: '2',
            //             icons: {
            //                 0: 'ketelkiezer_isolatie_minimaal.svg',

            //             }
            //         }
            //     }
            // },
            // 3: {
            //     tekst: 'Hoe groot is uw woning',
            //     shortTekst: "Woninginhoud",
            //     filter: true,
            //     velden: {
            //         0: {

            //             label: '< 250 m3',
            //             value: '250',
            //         },
            //         1: {
            //             label: '> 250 m3',
            //             value: '450'
            //         },
            //         2: {
            //             label: '> 450 m3',
            //             value: '550'
            //         },
            //         3: {
            //             label: '> 550 m3',
            //             value: '700'
            //         },
            //         4: {
            //             label: '> 700 m3',
            //             value: '900'
            //         },
            //     }
            // },
            // 4: {
            //     tekst: 'Waarvoor gebruikt u warmwater in uw badkamer?',
            //     shortTekst: "Badkamer",
            //     filter: true,
            //     velden: {
            //         0: {

            //             label: 'Alleen douche',
            //             value: '0',
            //             icons: {
            //                 0: 'ketelkiezer_douche.svg',

            //             }
            //         },
            //         1: {
            //             label: 'Douche en bad',
            //             value: '1',
            //             icons: {
            //                 0: 'ketelkiezer_douche.svg',
            //                 1: 'ketelkiezer_bad.svg',

            //             }
            //         },
            //         2: {
            //             label: 'Douchebad',
            //             value: '2',
            //             icons: {
            //                 0: 'ketelkiezer_douchebad.svg',

            //             }
            //         },
            //     }
            // },

            // 5: {
            //     tekst: 'Welke douchekop gebruikt u?',
            //     shortTekst: "Douchekop",
            //     filter: true,
            //     velden: {
            //         0: {

            //             label: 'Spaar douche',
            //             value: '0',
            //             icons: {
            //                 0: 'ketelkiezer_douche_spaar.svg',
            //             }
            //         },
            //         1: {
            //             label: 'Normale douche',
            //             value: '1',
            //             icons: {
            //                 0: 'ketelkiezer_douche_normaal.svg',
            //             }
            //         },
            //         2: {
            //             label: 'Stort douche',
            //             value: '2',
            //             icons: {
            //                 0: 'ketelkiezer_douche_stort.svg',
            //             }
            //         },
            //     }
            // },


            // 6: {
            //     tekst: 'Wilt u overal gelijktijdig warmwater kunnen gebruiken?',
            //     shortTekst: "Gelijktijdig gebruik",
            //     filter: true,
            //     velden: {
            //         0: {

            //             label: 'Nee',
            //             value: '0',
            //             icons: {
            //                 0: 'ketelkiezer_douche.svg',
            //             }
            //         },
            //         1: {
            //             label: 'Ja',
            //             value: '1',
            //             icons: {
            //                 0: 'ketelkiezer_douche.svg',

            //             }
            //         }
            //     }
            // },



        };



        $timeout(function() {
            $scope.alleKetels();
        });



    }]);


})();